// Icons
import { TbPigMoney } from "react-icons/tb";

// Types
import { useMemo } from "react";
import type { IBrokerageProps } from "./types";

export function Brokerage({ houseAmount, setBrokerageAmount }: IBrokerageProps) {

    // AUX Variable
    const brokarage_6 = useMemo(() => houseAmount * 0.6, [houseAmount]);
    const brokarage_5 = useMemo(() => houseAmount * 0.5, [houseAmount]);
    const brokarage_1 = useMemo(() => houseAmount * 0.1, [houseAmount]);
    const brokarage_0 = useMemo(() => houseAmount * 0.0, [houseAmount]);
    return (<span style={{
        maxWidth: 'calc(50% - 0.75rem)',
        minWidth: 'calc(50% - 0.75rem)',
    }} className="max-sm:!w-full max-sm:!min-w-full max-sm:!max-w-ful md:flex-1 h-auto flex flex-col justify-start gap-3
            rounded-xl
            border-slate-200 border-[1px]
            bg-white shadow-md overflow-hidden
        "
    >
        <span className="w-full flex flex-row items-center gap-2 px-4 pt-4 pb-2 border-slate-200 border-b-[1px]">
            <TbPigMoney size={25} />
            <span className="font-semibold">Corretagem</span>
        </span>

        <span className="w-full h-auto flex flex-col gap-3 p-4">
            <input type="radio" name="vgv_option" id="brokarage_6" className="peer/BKG6 hidden" />
            <input type="radio" name="vgv_option" id="brokarage_5" className="peer/BKG5 hidden" />
            <input type="radio" name="vgv_option" id="brokarage_1" className="peer/BKG1 hidden" />
            <input type="radio" name="vgv_option" id="brokarage_0" className="peer/BKG0 hidden" />

            <label title="Clique para selecionar" htmlFor="brokarage_6" onClick={() => setBrokerageAmount(brokarage_6)} className="w-full h-auto cursor-pointer
                flex flex-row items-center justify-between gap-4 hover:bg-slate-100 peer-checked/BKG6:bg-slate-200 p-2 rounded-xl">
                <span>6%</span>
                <span className="font-semibold">
                    {
                        Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                            unitDisplay: 'short'
                        }).format(brokarage_6)
                    }
                </span>
            </label>

            <label title="Clique para selecionar" htmlFor="brokarage_5" onClick={() => setBrokerageAmount(brokarage_5)} className="w-full h-auto cursor-pointer
                        flex flex-row items-center justify-between gap-4 hover:bg-slate-100 peer-checked/BKG5:bg-slate-200 p-2 rounded-xl">
                <span>5%</span>
                <span className="font-semibold">
                    {
                        Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                            unitDisplay: 'short'
                        }).format(houseAmount * 0.05)
                    }
                </span>
            </label>

            <label title="Clique para selecionar" htmlFor="brokarage_1" onClick={() => setBrokerageAmount(brokarage_1)} className="w-full h-auto cursor-pointer
                        flex flex-row items-center justify-between gap-4 hover:bg-slate-100 peer-checked/BKG1:bg-slate-200 p-2 rounded-xl">
                <span>1%</span>
                <span className="font-semibold">
                    {
                        Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                            unitDisplay: 'short'
                        }).format(brokarage_1)
                    }
                </span>
            </label>

            <label title="Clique para selecionar" htmlFor="brokarage_0" onClick={() => setBrokerageAmount(brokarage_0)} className="w-full h-auto cursor-pointer
                        flex flex-row items-center justify-between gap-4 hover:bg-slate-100 peer-checked/BKG0:bg-slate-200 p-2 rounded-xl">
                <span>0%</span>
                <span className="font-semibold">
                    {
                        Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                            unitDisplay: 'short'
                        }).format(brokarage_0)
                    }
                </span>
            </label>
        </span>
    </span>
    )
}
